import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { RequestForQuoteSupplierResponseLineItemData } from "@interfaces/data/requestForQuoteSupplierResponseLineItemData.interface";
import { RequestForQuoteSupplierResponseDto } from "@interfaces/dto/requestForQuoteSupplierResponseDto.interface";
import { RequestForQuoteService } from "@services/requestForQuote.service";
import { ToastService } from "angular-toastify";
import { Guid } from "guid-typescript";

/**
 * Public (logged out) Approved Supplier Questionnaire — a digital Doc 31 rev 5. Reached from an emailed
 * link; the lookupId in the route is the credential, so an invalid/used link shows a friendly message.
 */
@Component({
	moduleId: module.id,
	selector: "supplierRequestForQuoteResponse",
	styleUrls: ["supplierRequestForQuoteResponse.css"],
	templateUrl: "supplierRequestForQuoteResponse.html"
})
export class SupplierRequestForQuoteResponsePublicComponent {
	errorMessage = "";
	lineItems: RequestForQuoteSupplierResponseLineItemData[] = [];
	loading = true;
	lookupId = "";
	saving = false;
	submitted = false;

	constructor(private route: ActivatedRoute, private toastService: ToastService, private requestForQuoteService: RequestForQuoteService) {
		this.route.params.subscribe((params) => {
			this.lookupId = params.lookupId;
			this.getLineItems();
		});
	}

	getLineItems() {
		this.loading = true;
		this.requestForQuoteService.public_ItemsForSupplierResponse(Guid.parse(this.lookupId))
			.subscribe(
				(res: any) => {
					this.lineItems = res.response;
					this.loading = false;
				},
				(err) => {
					console.log(err);
					this.loading = false;
					this.errorMessage = "This RFQ form link is not valid, or has already been completed. Please contact BPL Engineering Group if you believe this is a mistake.";
				}
			);
	}

	submit() {
		const badPrices = this.lineItems.filter(li => li.linePrice <= 0);
		if (badPrices.length > 0) {
			alert("Please ensure you have entered all pricing.");
			return;
		}

		const lineItemJson = JSON.stringify(this.lineItems);
		
		const dto = new RequestForQuoteSupplierResponseDto();
		dto.lineItems = lineItemJson;
		dto.lookupId = this.lookupId;
		this.loading = true;
		this.requestForQuoteService.public_SupplierSubmittedResponse(dto)
			.subscribe(
				() => {
					this.loading = false;
					this.submitted = true;
				},
				(err) => {
					console.log(err);
					this.loading = false;
					this.submitted = false;
					alert("Something went wrong with your submission, please double check the details entered or contact BPL directly.");
				}
			);

	}
}
